import Vue from 'vue'
import Vuex from 'vuex'

import root from './root'
import app from './app'
import appView from './app-view'
import user from './user'
import group from './group'
import product from './product'
import message from './message'
import component from './component'
import packageApp from './package'
import guide from './guide'
import icon from './icon'
import wxplatform from './wxplatform'
import services from './services'
import arrangement from './arrangement'

Vue.use(Vuex)

const store = new Vuex.Store({
    ...root,
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        app,
        appView,
        user,
        group,
        product,
        message,
        component,
        guide,
        icon,
        package: packageApp,
        wxplatform,
        services,
        arrangement
    }
})

export default store
